"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8840],{

/***/ 8840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MarkdownEmbeddedComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/markdown/markdown.scss.js


var BOX_ELEMENTS_MARGIN = "40px 0";
var BOX_BORDER_RADIUS = "8px";
var BOX_BORDER = "1px solid ".concat(colors/* default.border-gray */.Z["border-gray"]);
var StyledMarkdown = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e2299cy0"
})("font-size:1rem;strong{font-weight:700;}h1{font-size:2.925rem;margin:40px 0;font-weight:500;}h2{font-size:1.75rem;font-weight:700;margin-top:56px;}h3{margin-top:40px;font-weight:700;font-size:1.125rem;}h4{font-weight:700;font-size:1.125rem;margin-bottom:20px;}p{line-height:30px;}ul,ol{line-height:40px;padding-inline-start:20px;}a{color:", colors/* default.brand-blue */.Z["brand-blue"], ";text-decoration:none;}blockquote{border-radius:", BOX_BORDER_RADIUS, ";box-shadow:0px 4px 40px rgba(0,0,0,0.08);border-left:", colors/* default.dodger-blue */.Z["dodger-blue"], " 6px solid;margin:", BOX_ELEMENTS_MARGIN, ";p{padding:20px 32px;}}img{margin-top:40px;border-radius:", BOX_BORDER_RADIUS, ";border:", BOX_BORDER, ";max-width:100%;}code{background-color:", colors/* default.riverstone */.Z.riverstone, ";border-radius:4px;padding:2px 6px 4px 6px;}pre{border:", BOX_BORDER, ";border-radius:", BOX_BORDER_RADIUS, ";padding:12px 24px !important;background:none !important;margin:", BOX_ELEMENTS_MARGIN, " !important;overflow:auto !important;max-width:900px !important;code{span{font-family:monospace,monospace;}}}table{border:", BOX_BORDER, ";border-radius:", BOX_BORDER_RADIUS, ";border-collapse:separate;border-spacing:0;margin:", BOX_ELEMENTS_MARGIN, ";th{border-bottom:", BOX_BORDER, ";text-align:left;}th,td{padding:20px;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/markdown/default-props.js
/* harmony default export */ var default_props = ({
    input: "# This is a header\n\nAnd this is a paragraph"
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./segments/desktop/core-components/markdown/markdown.js









var ReactMarkdown = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9432), __webpack_require__.e(7552)]).then(__webpack_require__.t.bind(__webpack_require__, 17552, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17552)
            ];
        }
    }
});
var CodeBlock = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4251), __webpack_require__.e(1125)]).then(__webpack_require__.bind(__webpack_require__, 91125));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91125)
            ];
        }
    }
});
var Markdown = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Markdown, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Markdown);
    function Markdown() {
        (0,_class_call_check/* default */.Z)(this, Markdown);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Markdown, [
        {
            key: "render",
            value: function render() {
                var input = this.props.input;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMarkdown, {
                    className: "markdown",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactMarkdown, {
                        source: input,
                        escapeHtml: false,
                        renderers: {
                            code: CodeBlock
                        }
                    })
                });
            }
        }
    ]);
    return Markdown;
}(react.PureComponent);

Markdown.defaultProps = default_props;

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/markdown-embedded/markdown-embedded-component.scss.js


var StyledMarkdownEmbeddedComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16ujzb70"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.markdown-wrapper{padding:0 32px;}");

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/markdown-embedded/markdown-embedded-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var MarkdownEmbeddedComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MarkdownEmbeddedComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MarkdownEmbeddedComponent);
    function MarkdownEmbeddedComponent() {
        (0,_class_call_check/* default */.Z)(this, MarkdownEmbeddedComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MarkdownEmbeddedComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMarkdownEmbeddedComponent, {
                    className: "markdown-embedded-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "markdown-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown, _object_spread({}, this.props))
                    })
                });
            }
        }
    ]);
    return MarkdownEmbeddedComponent;
}(react.PureComponent);

MarkdownEmbeddedComponent.defaultProps = Markdown.defaultProps;


/***/ })

}]);